import { render, staticRenderFns } from "./StudentWorkInfoView.vue?vue&type=template&id=286743b8&scoped=true"
import script from "./StudentWorkInfoView.vue?vue&type=script&lang=js"
export * from "./StudentWorkInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286743b8",
  null
  
)

export default component.exports